import * as React from 'react';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import { getTimeRangeFromString } from "../../../../utils/utils";

export default function WorkTimeline() {
  return (
    <div className={'a-timeline'}>
      <h2>Work experience</h2>
      <Timeline position="alternate">
        <TimelineItem>
          <TimelineSeparator>
            <TimelineDot color="secondary" />
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent>
            <div className={'a-company'}>
              <div className={'a-com-icon'}>
                <img src={'https://raw.githubusercontent.com/tienmanh2208/public-asset-depressed-developer/master/personal-info/sotatek.png'} alt={'Company name'}/>
              </div>
              <div className={'a-com-info'}>
                <div className={'a-com-name'}>Sotatek</div>
                <div className={'a-com-time'}>Apr 2021 - Now</div>
                <div className={'a-com-time'}>({getTimeRangeFromString('2021-04-01', new Date().toISOString())})</div>
                <div className={'a-com-position'}>Backend Engineer</div>
              </div>
            </div>
          </TimelineContent>
        </TimelineItem>
        <TimelineItem>
          <TimelineSeparator>
            <TimelineDot color="success" />
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent>
            <div className={'a-company'} style={{justifyContent: 'right'}}>
              <div className={'a-com-info'}>
                <div className={'a-com-name'}>Viettel Solution</div>
                <div className={'a-com-time'}>2021-02-01 - 2021-04-01</div>
                <div className={'a-com-time'}>({getTimeRangeFromString('2021-02-01', '2021-04-01')})</div>
                <div className={'a-com-position'}>Software Engineer</div>
              </div>
              <div className={'a-com-icon'}>
                <img src={'https://raw.githubusercontent.com/tienmanh2208/public-asset-depressed-developer/master/personal-info/viettel.jpeg'} alt={'Company name'}/>
              </div>
            </div>
          </TimelineContent>
        </TimelineItem>
        <TimelineItem>
          <TimelineSeparator>
            <TimelineDot color="error" />
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent>
            <div className={'a-company'}>
              <div className={'a-com-icon'}>
                <img style={{backgroundColor: 'white'}} src={'https://raw.githubusercontent.com/tienmanh2208/public-asset-depressed-developer/master/personal-info/hblab.png'} alt={'Company name'}/>
              </div>
              <div className={'a-com-info'}>
                <div className={'a-com-name'}>HBLab</div>
                <div className={'a-com-time'}>2019-05-01 - 2021-02-01</div>
                <div className={'a-com-time'}>({getTimeRangeFromString('2019-05-01', '2021-02-01')})</div>
                <div className={'a-com-position'}>Backend Developer</div>
              </div>
            </div>
          </TimelineContent>
        </TimelineItem>
        <TimelineItem>
          <TimelineSeparator>
            <TimelineDot color="info"/>
            <TimelineConnector />
          </TimelineSeparator>
          <TimelineContent>
            <div className={'a-company'} style={{justifyContent: 'right'}}>
              <div className={'a-com-info'}>
                <div className={'a-com-name'}>VNP</div>
                <div className={'a-com-time'}>2018-10-01 - 2019-04-01</div>
                <div className={'a-com-time'}>({getTimeRangeFromString('2018-10-01', '2019-04-01')})</div>
                <div className={'a-com-position'}>Intern</div>
              </div>
              <div className={'a-com-icon'}>
                <img src={'https://raw.githubusercontent.com/tienmanh2208/public-asset-depressed-developer/master/personal-info/vnp.png'} alt={'Company name'}/>
              </div>
            </div>
          </TimelineContent>
        </TimelineItem>
      </Timeline>
    </div>
  );
}
